import { useEffect, useRef } from 'react';
import type { GridApi } from '@dataGrid/MasterDetails';
import type { SwapBoardTrailer } from '../types';
import { applyDetailGridSelection } from '../detailGridUtils';

type UseDetailGridSelectionSyncParams = {
  activePickupId: string | null;
  clearSelectionCount: number;
  onDetailSelectionChanged?: (selectedRow: SwapBoardTrailer | null) => void;
};

export const useDetailGridSelectionSync = ({
  activePickupId,
  clearSelectionCount,
  onDetailSelectionChanged,
}: UseDetailGridSelectionSyncParams) => {
  const gridApiRef = useRef<GridApi | null>(null);
  const isSyncingSelectionRef = useRef(false);

  const syncSelection = (api: GridApi | null | undefined) => {
    if (!api) return;
    isSyncingSelectionRef.current = true;
    applyDetailGridSelection({ api, activePickupId });
    isSyncingSelectionRef.current = false;
  };

  useEffect(() => {
    syncSelection(gridApiRef.current);
  }, [activePickupId, clearSelectionCount]);

  return {
    onGridReady: ({ api }: { api: GridApi }) => {
      gridApiRef.current = api;
      syncSelection(api);
    },
    onSelectionChanged: (event: { source?: string }) => {
      if (isSyncingSelectionRef.current || event?.source === 'api') return;
      const selectedRows = gridApiRef.current?.getSelectedRows?.() || [];
      onDetailSelectionChanged?.((selectedRows[0] as SwapBoardTrailer) ?? null);
    },
  };
};
